export const MCP_ID_PREFIX = "mcp/";

// Top-level scalar pairs only (the scan stops at the first object/array); string escapes are limited to valid JSON so JSON.parse cannot throw.
export const MCP_ENVELOPE_PAIR =
  /,?"([^"\\]*)":("(?:[^"\\]|\\["\\/bfnrt]|\\u[0-9a-fA-F]{4})*"|true|false|null|-?\d+(?:\.\d+)?)/y;

export const MCP_ENVELOPE_KEYS = ["server", "reason"];
